import { render, staticRenderFns } from "./Zhuque.vue?vue&type=template&id=5489a2ac&scoped=true"
import script from "./Zhuque.vue?vue&type=script&lang=js"
export * from "./Zhuque.vue?vue&type=script&lang=js"
import style0 from "./Zhuque.vue?vue&type=style&index=0&id=5489a2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489a2ac",
  null
  
)

export default component.exports